import { Navigate, Route, Routes, Outlet } from 'react-router-dom'
import { DocumentLibrary } from './components/DocumentLibrary'
import { useAuth } from '../auth'
import QhseDashboard from './components/QhseDashboard'
import { QHSE_PERMS } from './core/permissions'
import { VesselCertificates } from './components/VesselCertificates';
import { OfficeCertificates } from './components/OfficeCertificates';
import ManualsAndPlans from './components/ManualsAndPlans';
import InspectionIndex from './components/InspectionIndex';
import InspectionPlanning from './components/InspectionPlanning';

import DefectListPage from './components/DefectListPage';
import { ComingSoon } from '../common/ComingSoon';
import InspectionFindingIndex from './components/InspectionFindingIndex';
import AuditIndex from './components/AuditIndex';
import AuditPlanning from './components/AuditPlanning';
import AuditFindingIndex from './components/AuditFindingIndex';
import NearMissReports from './components/NearMissReports';
import RiskAssessmentLibraryPage from './components/RiskAssessmentLibrary/RiskAssessmentLibraryPage';
import TechnicalFormsPage from '../Technical/components/Forms/TechnicalFormsPage';
import QhseLibraryPage from './components/QhseLibraryPage';
import SafetyCommitteeMeetingPage from './components/SafetyCommitteeMeetingPage';
import WorkPermitsAndChecklistsPage from './components/WorkPermitsAndChecklistsPage';
import MainEngineConsumptionPage from './components/MainEngineConsumptionPage';
import MachineryStatusPage from './components/MachineryStatusPage';
import MonthEndLibraryPage from './components/MonthEndLibraryPage';
import MonthsEndReportTabsPage from './components/MonthsEndReportTabsPage';
import { RequireQhseRouteView } from './core/menuAccess';

const QHSEPage = () => {
  const { can, permissionsLoaded } = useAuth()

  const RequirePerm: React.FC<{ perm: string; children: React.ReactNode }> = ({ perm, children }) => {
    if (!permissionsLoaded) {
      return (
        <div className='d-flex justify-content-center align-items-center p-10 text-muted'>
          Loading permissions...
        </div>
      )
    }
    if (!can(perm)) {
      return (
        <div className='d-flex justify-content-center align-items-center p-10 text-muted'>
          You do not have access to this page.
        </div>
      )
    }
    return <>{children}</>
  }
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          index
          element={<Navigate to={'dashboard'} replace />}  // ✅ Default to dashboard
        />
        <Route
          path='dashboard'
          element={<QhseDashboard />}
        />
        <Route
          path='document-library'
          element={
            <RequireQhseRouteView routeKey='documentLibrary'>
              <RequirePerm perm={QHSE_PERMS.DOC_READ}>
                <DocumentLibrary />
              </RequirePerm>
            </RequireQhseRouteView>
          }
        />
        <Route
          path='vessel-certificates'
          element={
            <RequireQhseRouteView routeKey='vesselCertificates'>
              <RequirePerm perm={QHSE_PERMS.CERT_READ}>
                <VesselCertificates />
              </RequirePerm>
            </RequireQhseRouteView>
          }
        />
        <Route
          path='office-certificates'
          element={
            <RequireQhseRouteView routeKey='officeCertificates'>
              <RequirePerm perm={QHSE_PERMS.OFFICE_CERT_READ}>
                <OfficeCertificates />
              </RequirePerm>
            </RequireQhseRouteView>
          }
        />
        <Route
          path='manuals-and-plans'
          element={
            <RequireQhseRouteView routeKey='manualsAndPlans'>
              <RequirePerm perm={QHSE_PERMS.MANUAL_PLAN_READ}>
                <ManualsAndPlans />
              </RequirePerm>
            </RequireQhseRouteView>
          }
        />
        <Route path='forms-checklists' element={<Outlet />}>
          <Route index element={<Navigate to='submissions' replace />} />
          <Route
            path='submissions'
            element={
              <RequireQhseRouteView routeKey='formsChecklistsSubmissions'>
                <RequirePerm perm={QHSE_PERMS.FORM_SUBMISSION_READ}>
                  <TechnicalFormsPage />
                </RequirePerm>
              </RequireQhseRouteView>
            }
          />
          <Route
            path='library'
            element={
              <RequireQhseRouteView routeKey='formsChecklistsLibrary'>
                <RequirePerm perm={QHSE_PERMS.FORM_TEMPLATE_READ}>
                  <QhseLibraryPage />
                </RequirePerm>
              </RequireQhseRouteView>
            }
          />
        </Route>

        <Route path='audits-and-inspection' element={<Navigate to='/qhse/audit-index' replace />} />
        <Route path='vessel-audits' element={<Navigate to='/qhse/audit-index' replace />} />
        <Route path='vessel-inspection' element={<Navigate to='/qhse/inspindex' replace />} />
        <Route path='ncr-index' element={<Navigate to='/qhse/inspection-findings' replace />} />
        <Route path='incident-report' element={<Navigate to='/qhse/accident-near-miss-reports' replace />} />
        <Route path='masters-sms-review' element={<Navigate to='/qhse/dashboard' replace />} />

        <Route
          path='inspindex'
          element={
            <RequireQhseRouteView routeKey='vesselInspection'>
              <RequirePerm perm={QHSE_PERMS.INSPECTION_READ}>
                <InspectionIndex />
              </RequirePerm>
            </RequireQhseRouteView>
          }
        />

        <Route
          path='insplanning'
          element={
            <RequireQhseRouteView routeKey='vesselInspection'>
              <RequirePerm perm={QHSE_PERMS.INSPECTION_PLAN_READ}>
                <InspectionPlanning />
              </RequirePerm>
            </RequireQhseRouteView>
          }
        />

        {/* <Route
                    path='inspfindings'
                    element={<InspectionFindingsIndex />}
                /> */}
        <Route
          path='inspection-findings'
          element={
            <RequireQhseRouteView routeKey='vesselInspection'>
              <RequirePerm perm={QHSE_PERMS.INSPECTION_FINDING_READ}>
                <InspectionFindingIndex />
              </RequirePerm>
            </RequireQhseRouteView>
          }
        />
        <Route
          path='defects-list'
          element={
            <RequireQhseRouteView routeKey='defectsList'>
              <RequirePerm perm={QHSE_PERMS.DEFECT_READ}>
                <DefectListPage />
              </RequirePerm>
            </RequireQhseRouteView>
          }
        />
        {/* 🔹 NEW QHSE Coming Soon pages */}
        <Route
          path='audit-index'
          element={
            <RequireQhseRouteView routeKey='vesselAudits'>
              <RequirePerm perm={QHSE_PERMS.AUDIT_READ}>
                <AuditIndex />
              </RequirePerm>
            </RequireQhseRouteView>
          }
        />
        <Route
          path='audit-planning'
          element={
            <RequireQhseRouteView routeKey='vesselAudits'>
              <RequirePerm perm={QHSE_PERMS.AUDIT_PLAN_READ}>
                <AuditPlanning />
              </RequirePerm>
            </RequireQhseRouteView>
          }
        />
        <Route
          path='audit-findings'
          element={
            <RequireQhseRouteView routeKey='vesselAudits'>
              <RequirePerm perm={QHSE_PERMS.AUDIT_FINDING_READ}>
                <AuditFindingIndex />
              </RequirePerm>
            </RequireQhseRouteView>
          }
        />

        <Route
          path='accident-near-miss-reports'
          element={
            <RequireQhseRouteView routeKey='nearMissReports'>
              <RequirePerm perm={QHSE_PERMS.NEAR_MISS_READ}>
                <NearMissReports />
              </RequirePerm>
            </RequireQhseRouteView>
          }
        />
        <Route path='risk-assessment-form' element={<Navigate to='/qhse/risk-assessment' replace />} />
        <Route
          path='risk-assessment'
          element={
            <RequireQhseRouteView routeKey='riskAssessmentLibrary'>
              <RequirePerm perm={QHSE_PERMS.RISK_LIB_READ}>
                <RiskAssessmentLibraryPage />
              </RequirePerm>
            </RequireQhseRouteView>
          }
        />
        <Route
          path='safety-committee-meeting'
          element={
            <RequireQhseRouteView routeKey='safetyCommitteeMeeting'>
              <RequirePerm perm={QHSE_PERMS.SAFETY_COMMITTEE_READ}>
                <SafetyCommitteeMeetingPage />
              </RequirePerm>
            </RequireQhseRouteView>
          }
        />
        <Route
          path='work-permits-and-checklists'
          element={
            <RequireQhseRouteView routeKey='workPermitsAndChecklists'>
              <RequirePerm perm={QHSE_PERMS.WORK_PERMIT_READ}>
                <WorkPermitsAndChecklistsPage />
              </RequirePerm>
            </RequireQhseRouteView>
          }
        />

        <Route
          path='month-end-reports'
          element={
            <RequireQhseRouteView routeKey='monthEndLibrary'>
              <MonthEndLibraryPage />
            </RequireQhseRouteView>
          }
        />
        <Route
          path='month-end-reports/main-engine-consumption'
          element={
            <RequireQhseRouteView routeKey='monthEndLibrary'>
              <MainEngineConsumptionPage />
            </RequireQhseRouteView>
          }
        />
        <Route
          path='month-end-reports/machinery-status'
          element={
            <RequireQhseRouteView routeKey='monthEndLibrary'>
              <MachineryStatusPage />
            </RequireQhseRouteView>
          }
        />
        <Route
          path='month-end-reports/months-end-report'
          element={
            <RequireQhseRouteView routeKey='monthEndLibrary'>
              <MonthsEndReportTabsPage />
            </RequireQhseRouteView>
          }
        />

        <Route
          path='emergency-drills/planner'
          element={<ComingSoon title='Drill Planner' />}
        />
        <Route
          path='emergency-drills/report'
          element={<ComingSoon title='Emergency Drill Report' />}
        />
        <Route
          path='emergency-drills/review'
          element={<ComingSoon title='Emergency Drill Review' />}
        />
      </Route>

    </Routes>
  )
}

export default QHSEPage
